module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "right-panel md-elevation-1 md-scrollbar md-theme-default",
    attrs: {
      "id": "action-group"
    }
  }, [_c('div', {
    staticClass: "md-layout-row header"
  }, [_c('div', {
    staticClass: "md-flex"
  }, [_c('md-button', {
    staticClass: "md-icon-button md-dense close small",
    attrs: {
      "to": {
        name: 'UserModuleActions',
        params: {
          code: _vm.$route.params.code
        },
        query: _vm.$route.query
      }
    }
  }, [_c('md-icon', [_vm._v("close")])], 1), (_vm.action) ? _c('div', {
    staticClass: "md-body-1"
  }, [_vm._v(_vm._s(_vm.action.name))]) : _vm._e()], 1)]), _c('div', {
    staticClass: "md-caption"
  }, [_vm._v("Группы:"), _vm._l((_vm.groups), function(group) {
    return _c('md-chip', {
      key: group.id,
      staticClass: "small",
      attrs: {
        "md-deletable": "md-deletable"
      },
      on: {
        "md-delete": function($event) {
          _vm.removeUserGroupFromAction(group.code)
        }
      }
    }, [_vm._v(_vm._s(group.name))])
  }), _c('md-button', {
    staticClass: "md-icon-button small add",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.showAddGroupSelect = true
      }
    }
  }, [_c('md-icon', [_vm._v("add")])], 1)], 2), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showAddGroupSelect),
      expression: "showAddGroupSelect"
    }],
    staticClass: "md-flex"
  }, [(_vm.usersGroups.length) ? _c('md-field', {
    attrs: {
      "md-theme": "white"
    }
  }, [_c('label', {
    attrs: {
      "for": "add-groups"
    }
  }, [_vm._v("Выберете группу")]), _c('md-select', {
    attrs: {
      "id": "add-groups",
      "name": "movies"
    },
    model: {
      value: (_vm.addGroups),
      callback: function($$v) {
        _vm.addGroups = $$v
      },
      expression: "addGroups"
    }
  }, _vm._l((_vm.usersGroups), function(group) {
    return _c('md-option', {
      key: group.id,
      attrs: {
        "value": group.code
      }
    }, [_vm._v(_vm._s(group.name))])
  })), _c('md-button', {
    staticClass: "md-icon-button md-dense",
    on: {
      "click": function($event) {
        _vm.postUserGroupToAction()
      }
    }
  }, [_c('md-icon', [_vm._v("done")])], 1), _c('md-button', {
    staticClass: "md-icon-button md-dense",
    on: {
      "click": function($event) {
        _vm.showAddGroupSelect = false
      }
    }
  }, [_c('md-icon', [_vm._v("close")])], 1)], 1) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b30826e6","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/users/views/Action.vue
// module id = 1240
// module chunks = 0